import { FC } from 'react';
import CalculateOutlined from '@mui/icons-material/CalculateOutlined';
import TabsPanel from 'further-ui/components/TabsPanel';
import Page from 'components/new/Page';
import BalanceSheet from './BalanceSheet';
import GeneralLedger from './GeneralLedger';
import TrialBalance from './TrialBalance';
import IncomeStatement from './IncomeStatement';
import CashFlowStatement from './CashFlowStatement';
import ScheduleOfInvestments from './ScheduleOfInvestments';

const FundAccounting: FC = () => {
  const tabs = [
    {
      key: 'general-ledger',
      label: 'General ledger',
      urlParam: 'general-ledger',
      content: <GeneralLedger />,
    },
    {
      key: 'trial-balance',
      label: 'Trial balance',
      urlParam: 'trial-balance',
      content: <TrialBalance />,
    },
    {
      key: 'balance-sheet',
      label: 'Balance sheet',
      urlParam: 'balance-sheet',
      content: <BalanceSheet />,
    },
    {
      key: 'income-statement',
      label: 'Income statement',
      urlParam: 'income-statement',
      content: <IncomeStatement />,
    },
    {
      key: 'cash-flow-statement',
      label: 'Cash flow statement',
      urlParam: 'cash-flow-statement',
      content: <CashFlowStatement />,
    },
    {
      key: 'schedule-of-investments',
      label: 'Schedule of investments',
      urlParam: 'schedule-of-investments',
      content: <ScheduleOfInvestments />,
    },
  ];

  return (
    <Page
      tabTitle="Accounting"
      heading="Accounting"
      headingIcon={CalculateOutlined}
      spacing="sm"
    >
      <TabsPanel keepAlive useTabsUrls fullHeight tabs={tabs} />
    </Page>
  );
};

export default FundAccounting;
